import React, { Component } from "react";
import { Form } from "react-form";
import { connect } from "react-redux";

import { updateSmsReload, fetchSmsReload } from "actions/company";
import InputText from "components/form-fields/InputText";
import { toggleFullPageSpinner, toggleNotification } from "actions/toggle";

class AddSmsReload extends Component {
  componentDidMount() {
    const {
      match: {
        params: { companyId, smsReloadId }
      },
      fetchSmsReload
    } = this.props;
    fetchSmsReload(companyId, smsReloadId);
  }

  onSubmit = data => {
    const {
      match: {
        params: { companyId, smsReloadId }
      },
      history,
      updateSmsReload,
      toggleFullPageSpinner,
      toggleNotification
    } = this.props;

    updateSmsReload(companyId, smsReloadId, data)
      .then(() => {
        toggleNotification(true, {
          message: "Updated SMS Reload Successfully!",
          infoClassName: "is-success"
        });
        history.push(`/companies/${companyId}/sms-reloads`);
      })
      .catch(e => {
        toggleNotification(true, {
          message: e.message,
          infoClassName: "is-danger"
        });
      })
      .then(() => toggleFullPageSpinner(false));
  };

  render() {
    const { smsReload } = this.props;

    if (smsReload.loading) {
      return "loading";
    }

    return (
      <Form onSubmit={this.onSubmit} defaultValues={smsReload.data}>
        {formApi => (
          <form onSubmit={formApi.submitForm}>
            <div className="box">
              <div className="columns">
                <div className="column">
                  <InputText
                    required
                    field="amount"
                    label="Amount"
                    placeholder="Amount"
                    required
                  />
                </div>
              </div>
              <div className="columns">
                <div className="column">
                  <InputText
                    field="note"
                    label="Note"
                    placeholder="Note"
                    required
                  />
                </div>
              </div>
            </div>

            <button className="button is-fullwidth is-info is-medium">
              Submit
            </button>
          </form>
        )}
      </Form>
    );
  }
}

const mapStateToProps = ({ smsReload }) => ({ smsReload });

export default connect(mapStateToProps, {
  fetchSmsReload,
  updateSmsReload,
  toggleFullPageSpinner,
  toggleNotification
})(AddSmsReload);



// WEBPACK FOOTER //
// ./src/pages/Company/SmsReload/Edit.js